import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/foot-watch/$diaryId/new/instructions')({
    component: () => (
        <section className="max-w-md mx-auto">
            <Outlet />
        </section>
    ),
});
